import vis from 'vis-network'
import 'vis-network/dist/vis-network.min.css'
import { TopologyNode, TopologyEdge } from './topology'
import { findMostImportantIssue } from '@/services/issue'

const config: vis.Options = {
  nodes: {
    borderWidth: 0,
    color: {
      background: 'white',
      border: 'lightgray',
      highlight: 'rgba(0,0,0,.1)',
      hover: 'rgba(0,0,0,.1)'
    },
    scaling: {
      min: 16,
      max: 32
    },
    shapeProperties: {
      useBorderWithImage: true
    }
  },
  edges: {
    color: {
      color: 'grey'
    },
    smooth: {
      enabled: true,
      type: 'cubicBezier',
      forceDirection: 'horizontal',
      roundness: 0.4
    },
    arrows: {
      to: {
        scaleFactor: 0.7
      }
    }
  },
  physics: {
    adaptiveTimestep: false,
    barnesHut: {
      gravitationalConstant: -30000
    },
    stabilization: {
      iterations: 2500
    }
  },
  groups: {
    analytic: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    collector: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    database: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    report: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    portal: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    vault: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    },
    unknown: {
      shape: 'image',
      color: {
        border: '#2B7CE9'
      }
    }
  },
  layout: {
    randomSeed: 764,
    hierarchical: {
      direction: 'LR',
      sortMethod: 'directed'
    }
  },
  interaction: {
    hover: true
  }
}

function assignImages (node: TopologyNode & { image?: string }) {
  const status = (node.health && node.health.status) || 'unknown'
  const { availabilityIssue, performanceIssue } = node.health
  const issue = findMostImportantIssue(availabilityIssue, performanceIssue)
  if (issue) {
    node.image = require(`../assets/topology/${status.toLowerCase()}-${node.group}-${issue.severity}.svg`)
  } else {
    node.image = require(`../assets/topology/${status.toLowerCase()}-${node.group}-5.svg`)
  }
}

function cutLabel (label: string, labelLength: number) {
  if (label.length > labelLength + 3) {
    label = label.substring(0, labelLength) + '...'
  }
  return label
}

export function configure (
  element: any,
  nodes: TopologyNode[],
  labelLength: number,
  edges: TopologyEdge[],
  tooltip: any
) {
  nodes.forEach(assignImages)

  const network = new vis.Network(
    element,
    {
      nodes: new vis.DataSet(nodes.map((node) => {
        return { ...node, label: cutLabel(node.label, labelLength) }
      })),
      edges: new vis.DataSet(edges.map((edge: TopologyEdge & { arrows?: string }): vis.Edge => {
        const { label, ...ret } = edge
        ret.arrows = 'to'
        return ret
      }))
    },
    config
  )

  if (tooltip && tooltip.node) {
    network.on('hoverNode', (params: any) => tooltip.node.over(params.event, params.node))
    network.on('blurNode', () => tooltip.node.out())
  }

  return network
}

export function fitViewport (network: any) {
  network.fit()
}
